const Title = (props:{title:string}) => <div className='mainTitle'>{props.title}</div>
export default Title;